import env from "app/utils/env";

export const hasEmptyParams = url => {
	const searchParams = new URLSearchParams(new URL(url).search);
	let isEmpty = false;
	for (let value of searchParams.values()) {
		if (!value) {
			isEmpty = true;
			break;
		}
	}
	return isEmpty;
};

export const isRequestAborted = response => {
	return response?.code === "ERR_CANCELED";
};

export const removeTrailingSlash = url => {
	const cleanUrl = url.replace(/\/$/, "");

	return cleanUrl;
};

export const isTargetApiUrl = url => {
	if (!url) {
		return false;
	}

	const hotelOnlyApiUrl = env("HOTEL_ONLY_API_URL");
	const quoteApiUrl = env("QUOTE_API_URL");

	return (
		(hotelOnlyApiUrl && url.startsWith(hotelOnlyApiUrl)) ||
		(quoteApiUrl && url.startsWith(quoteApiUrl)) ||
		false
	);
};
